import React from "react";
import CrudTable from "../components/CrudTable";

const columns = [
  { key: "name", label: "Name" },
  { key: "email", label: "Email" },
  { key: "role", label: "Role" },
  { key: "phone", label: "Phone" },
  { key: "status", label: "Status", status: true },
];
const formFields = [
  { name: "name", label: "Full Name", required: true },
  { name: "email", label: "Email", required: true, type: "email" },
  { name: "phone", label: "Phone" },
  { name: "password", label: "Password (min 8)", type: "password", required: true, default: "" },
  { name: "role", label: "Role", type: "select", required: true, default: "brand_admin",
    options: [
      { value: "super_admin", label: "Super Admin" },
      { value: "brand_admin", label: "Brand Admin" },
      { value: "outlet_user", label: "Outlet User" },
      { value: "rushserv_user", label: "RushServ Engineer" },
      { value: "manufacturer_user", label: "Manufacturer User" },
    ] },
  { name: "brand_id", label: "Brand ID (if applicable)" },
  { name: "outlet_id", label: "Outlet ID (if applicable)" },
  { name: "manufacturer_id", label: "Manufacturer ID (if applicable)" },
  { name: "status", label: "Status", type: "select", default: "active",
    options: [{ value: "active", label: "Active" }, { value: "inactive", label: "Inactive" }] },
];

export default function Users() {
  return <CrudTable title="Users" description="Manage user accounts, roles & permissions across all portals." endpoint="/users" columns={columns} formFields={formFields} />;
}
